import React from 'react';
import { Box, Fade } from '@mui/material';

interface ConditionalRenderProps {
  show: boolean;
  children: React.ReactNode;
  useAnimation?: boolean;
  animationDuration?: number;
}

/**
 * A component for conditionally rendering content with optional fade animation.
 * This component completely removes content from the DOM when not shown to eliminate white space.
 */
const ConditionalRender: React.FC<ConditionalRenderProps> = ({
  show,
  children,
  useAnimation = false,
  animationDuration = 500
}) => {
  // If not showing and not using animation, render nothing
  if (!show) {
    return null;
  }

  // If showing content, render it directly
  return <>{children}</>;
};

export default ConditionalRender; 